const reasonsblocksup = (state = [], action) => {
    switch (action.type) {
      case 'SUPBLOCK':
      return {
          type: "SUPBLOCK",
          reasons: action.reasons
        }
      default:
        return state
    }
  }
  
  export default reasonsblocksup